import Swiper from 'swiper/bundle';

export default class Carousel {
  constructor(element) {
    this.element = element;
    this.options = {
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        el: this.element.querySelector('.swiper-pagination'),
      },
      navigation: {
        nextEl: this.element.querySelector('.swiper-button-next'),
        prevEl: this.element.querySelector('.swiper-button-prev'),
      },
    };

    this.init();
  }

  init() {
    this.setOptions();
    new Swiper(this.element, this.options);
  }

  setOptions() {
    if ('split' in this.element.dataset) {
      this.options.breakpoints = {
        768: {
          slidesPerView: 2.5,
        },
      };
    }

    if ('autoplay' in this.element.dataset) {
      this.options.autoplay = {
        delay: 3000,
        pauseOnMouseEnter: true,
        disableOnInteraction: false,
      };
    }

    if ('loop' in this.element.dataset) {
      this.options.loop = true;
    }
    if ('paginationType' in this.element.dataset) {
      this.options.pagination.type = this.element.dataset.paginationType;
      this.options.pagination.renderFraction = function (
        currentClass,
        totalClass,
      ) {
        return (
          '<span class="' +
          currentClass +
          '"></span>' +
          ' / ' +
          '<span class="' +
          totalClass +
          '"></span>'
        );
      };
      // Fonction pour ajouter le zéro initial
      this.options.pagination.formatFractionCurrent = function (number) {
        return String(number).padStart(2, '0');
      };
      this.options.pagination.formatFractionTotal = function (number) {
        return String(number).padStart(2, '0');
      };
    }

    if ('slides' in this.element.dataset) {
      this.options.slidesPerView =
        this.element.dataset.slides || this.options.slidesPerView;
    }
  }
}
